import React, { FC } from "react"

export const App: FC = () => {
  return <div className="app"></div>
}
